/**
 * Compares the current window.location.search with a query object
 * to see if there is a match.
 */
const matchQuery = (query = {}) => {
  if (Object.keys(query)?.length < 1) {
    return false;
  }
  const windowQuery = { ...new URLSearchParams(window?.location?.search) };
  let isMatch = true;
  for (const key in query) {
    if (windowQuery[key] !== query[key]) {
      isMatch = false;
      break;
    }
  }
  return isMatch;
};

export default matchQuery;
